import React from 'react'
import './index.scss'
import ConfirmationPopup from '@Components/Popups/ConfirmationPopup'
import { UserInfo } from '@Entities/user/user'

interface UserActionPopupProps {
    title: string
    user: UserInfo
    onCancel(): void
    onConfirm(): void
    disabled?: boolean
}

const UserActionPopup = (props: UserActionPopupProps) => {
    const { firstName, lastName, email } = props.user
    const disabled = !!props.disabled

    return (
        <ConfirmationPopup
            title={props.title}
            onCancel={props.onCancel}
            onConfirm={props.onConfirm}
            cancelButtonText="Cancel"
            confirmButtonText="Confirm"
            disabled={disabled}
        >
            <div className="actions-container">
                <p>
                    Name: <strong title={firstName + ' ' + lastName}>{firstName + ' ' + lastName}</strong>
                </p>
                <p>
                    Email: <strong title={email}>{email}</strong>
                </p>
            </div>
        </ConfirmationPopup>
    )
}

export default UserActionPopup
